module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Variação vinculada ao anúncio",
      "columns": 12
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variationTitle),
      expression: "variationTitle"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.variationTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.variationTitle = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (_vm.variation) ? _c('variation-attributes', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "productId": _vm.productId
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.variation) ? _c('attributes', {
    attrs: {
      "product": _vm.variation,
      "attributes": _vm.category.variations_attributes,
      "sourceVariation": _vm.sourceVariation
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1406b85e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/edit/variation/Single.vue
// module id = 2926
// module chunks = 0